document.querySelectorAll('.read-more-btn').forEach( (btn) => {
	btn.addEventListener('click', function () {
		let txtMore = 'Read More'
		let txtLess = 'Read Less'
		let moreContent = this.parentElement.querySelector('.read-more-content');
		this.classList.toggle('active');
		if (this.classList.contains('active')) {
			this.innerHTML = txtLess;
			moreContent.style.display = 'block';
		} else {
			this.innerHTML = txtMore;
			moreContent.style.display = 'none';
		}
	});
});